import React, { Fragment } from "react";
import LeftPanel from "../components/LeftPanel";
import Header from "../components/Header";
import Uploader from "../components/Uploader";

export default class UploadPage extends React.Component {
  constructor() {
    super();
    this.state = {
      showModalPopup: false,
    };
  }
  isShowPopup = (status) => {
    this.setState({ showModalPopup: status });
  };
  render() {
    return (
      <>
        <LeftPanel />
        <div className="right-side">
          <Header />
          <div className="itemavilabelitycontainer">
            <h1>Item</h1>
            <div className="horizontal-tabs">
              <div className="seats-tabs tabs active">ITEM</div>
              <div className="seats-tabs tabs">CATEGORY</div>
              <div className="seats-tabs tabs">ADD ON</div>
              <div className="seats-tabs tabs">SERVICE SIZE</div>
            </div>

            <div className="horizontal-tabs">
              <>
                <button
                  className="button_tabs"
                  onClick={() => this.isShowPopup(true)}
                >
                  Bulk Upload
                </button>
                <Uploader
                  showModalPopup={this.state.showModalPopup}
                  onPopupClose={this.isShowPopup}
                ></Uploader>
              </>
              <button className="button_tabs">+ ADD ONE</button>
              <button className="button_tabs">DOWNLOAD</button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
